<template>
  <div id="app"><router-view v-if="isRouterAlive" /></div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
/*cover*/
.el-button,
.el-table,
.el-form-item__label,
.el-form-item__content,
.el-input,
.el-radio,
.el-radio--medium.is-bordered .el-radio__label,
.el-radio__label,
.el-select-dropdown__item,
.el-checkbox__label,
.el-pagination__sizes .el-input .el-input__inner,
.el-pager li,
.el-divider__text, .el-link,
.el-picker-panel__shortcut,
.el-dialog__body,
.el-tree-node__label,
.el-tabs__item{
  font-size: 12px;
}
.el-tabs__item{ font-weight: bold;}

.el-dialog__body{ padding:10px 20px;}

.el-input__inner[type='number']{ padding-right: 0;}

.dialog-footer button{ padding: 9px 15pxs;}

body .el-table th.gutter{
   display: table-cell!important;
}
/* 超小屏幕（手机，小于 768px） */
@media only screen and (max-width: 767px) {
  .common-button-wrapper {
    padding-bottom: 50px!important;
    height: 150px!important;
    .el-button, button {
      font-size: 40px!important;
    }
  }
}
/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 768px) and (max-width: 1024px) { 
  .common-button-wrapper {
    padding-bottom: 50px!important;
    height: 150px!important;
    .el-button, button {
      font-size: 40px!important;
    }
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919px) { 
  .common-button-wrapper {
    padding-bottom: 0px!important;
    height: 50px!important;
    .el-button, button {
      font-size: 14px!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue